import React from 'react';
import { createRoot } from 'react-dom/client'
import './index.css';
import i18next from './i18n'

// css
import 'bootstrap/dist/css/bootstrap.min.css';
import 'leaflet/dist/leaflet.css';

// redux
import { Provider } from 'react-redux';
import { store } from './redux/store'

import { I18nextProvider } from 'react-i18next';
import App from './App';

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18next}>
      <App/>
    </I18nextProvider>
  </Provider>
);

